$(document).on('visibilitychange', function() {
    if (document.visibilityState === 'visible') {

        jQuery.ajax({
            url: BASE_URL + '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'refresh_header',
            },
            success: function (response) {
                response = JSON.parse( response );
                refresh_header(response.header);
            }
        });
    }
});


$(document).on('click', '.js-adjust-reservation-time', function(){
    let data_to_send = {
        action: 'adjust_pre_reserved_time',
        is_ajax: true
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {

        response = JSON.parse( response );

        if(response.success){
            reinit_time_countdown(true, response.notif);
            $('.js-adjust-reservation-time').attr('disabled', 'disabled');
        }
    })
});

function reinit_time_countdown(reset_time = false, success_notif = false){

    if(window.cart_countdown_interval !== undefined && window.cart_countdown_interval !== 'undefined'){
        clearInterval(window.cart_countdown_interval);
    }

    if(reset_time){
        timerElement.data('time', timerElement.data('max-time'));
    }else{
        timerElement = $('.js-reservation-timer');
    }

    window.cart_countdown_interval = setInterval(function() {
        reservation_time_interval();
    }, 1000);

    if(success_notif){
        notif('success', success_notif);
    }
}

var timerElement = $('.js-reservation-timer');
if(timerElement.length){
    window.cart_countdown_interval = setInterval(function() {
        reservation_time_interval();
    }, 1000);
}

function reservation_time_interval(){

    if (typeof timer2 == 'undefined') {
        if(timerElement.data('time') == undefined){
            clearInterval(window.cart_countdown_interval);
            return;
        }else{
            var timer2 = timerElement.data('time');
        }
    }

    let timer = timer2.split(':');
    //by parsing integer, I avoid all extra string processing
    let minutes = parseInt(timer[0], 10);
    let seconds = parseInt(timer[1], 10);
    if (minutes === 0 && seconds === 0) {
        check_cart_time_limit();
        clearInterval(window.setInterval);
    } else {
        seconds--;
        if (seconds < 0) {
            minutes--;
            seconds = 59;
        }

        let formattedMinutes = (minutes < 10) ? '0' + minutes : minutes;
        let formattedSeconds = (seconds < 10) ? '0' + seconds : seconds;

        timerElement.html(formattedMinutes + ':' + formattedSeconds);
        timerElement.data('time', formattedMinutes + ':' + formattedSeconds);

        if(minutes < 10){
            $('.js-adjust-reservation-time').removeAttr('disabled');
        }

    }
}
